import { list } from 'postcss'
import Swiper from 'swiper'
import { find } from '../utils/dom'

export default function () {
  const Home = find("[js-page='home']")
  if (!Home) return
  console.log('Page home')
  document.addEventListener('DOMContentLoaded', function () {
    function switchToListView(listButton, gridButton) {
      // Esconder todas as grids e mostrar todas as listas
      document.querySelectorAll('.estilo-grid').forEach((grid) => grid.classList.add('hidden'))
      document.querySelectorAll('.estilo-lista').forEach((lista) => lista.classList.remove('hidden'))
      // Esconder botão lista e mostrar botão grid
      listButton.classList.add('hidden')
      gridButton.classList.remove('hidden')
      // Mudar a grid para 1 coluna em todos os elementos com a classe image-grid
      document.querySelectorAll('.image-grid').forEach((grid) => {
        grid.classList.remove('grid-cols-3', 'lg:grid-cols-2', 'md3:grid-cols-1')
        grid.classList.add('grid-cols-1')
      })
    }
    function switchToGridView(listButton, gridButton) {
      // Esconder todas as listas e mostrar todas as grids
      document.querySelectorAll('.estilo-lista').forEach((lista) => lista.classList.add('hidden'))
      document.querySelectorAll('.estilo-grid').forEach((grid) => grid.classList.remove('hidden'))
      // Esconder botão grid e mostrar botão lista
      gridButton.classList.add('hidden')
      listButton.classList.remove('hidden')
      // Mudar grid-cols-1 para a grade responsiva em todos os elementos com a classe image-grid
      document.querySelectorAll('.image-grid').forEach((grid) => {
        grid.classList.remove('grid-cols-1')
        grid.classList.add('grid-cols-3', 'lg:grid-cols-2', 'md3:grid-cols-1')
      })
    }
    // List/grid buttons para mobile
    const listaButtonMobile = document.getElementById('lista-button-mobile')
    const gridButtonMobile = document.getElementById('grid-button-mobile')
    if ((listaButtonMobile, gridButtonMobile)) {
      listaButtonMobile.addEventListener('click', function () {
        switchToListView(listaButtonMobile, gridButtonMobile)
      })
      gridButtonMobile.addEventListener('click', function () {
        switchToGridView(listaButtonMobile, gridButtonMobile)
      })
    }
    // List/grid buttons para desktop
    const listaButton = document.getElementById('lista-button')
    const gridButton = document.getElementById('grid-button')
    if (listaButton && gridButton) {
      listaButton.addEventListener('click', function () {
        switchToListView(listaButton, gridButton)
      })
      gridButton.addEventListener('click', function () {
        switchToGridView(listaButton, gridButton)
      })
    }
  })
  // Controle do menu
  const menuBtn = document.getElementById('menu-btn')
  const menu = document.getElementById('menu')
  menuBtn.addEventListener('click', () => {
    menuBtn.classList.toggle('open')
    menu.classList.toggle('open')
    if (menuBtn.classList.contains('mobile')) {
      menuBtn.classList.toggle('scale-x-75')
    }
  })
  // exposição individual toggle sobre trabalho
  document.querySelectorAll('.sobre-trabalho').forEach((textSection) => {
		
    const toggleContainer = textSection.nextElementSibling
    if (toggleContainer) {
      const toggleBtns = toggleContainer.querySelectorAll('.sobre-trabalho-toggle')
      const isLastItem = Boolean(textSection.closest('.media-item')?.matches(':last-child'))
      toggleBtns.forEach((toggleBtn) => {
        toggleBtn.addEventListener('click', () => {
          if (textSection.style.maxHeight && textSection.style.maxHeight !== '0px') {
            textSection.style.maxHeight = '0px'
          } else {
            textSection.style.maxHeight = textSection.scrollHeight + 'px'
          }
          setTimeout(() => {
            toggleBtns.forEach((btn) => {
              const previousBtnText = btn.textContent
              const parentDiv = btn.parentNode

							const isMobile = window.matchMedia('(max-width: 768px)').matches

              if (previousBtnText.trim().startsWith('[+')) {
                btn.textContent = previousBtnText.replace('[+]', '[-]')
              } else if (previousBtnText.trim().startsWith('[-')) {
                btn.textContent = previousBtnText.replace('[-]', '[+]')
              }
              if (isLastItem) {
                parentDiv.style.marginBottom = '0px'
                parentDiv.style.marginTop = parentDiv.style.marginTop !== '0px' ? '0px' : '12px'
                return
              }
              if (parentDiv.style.marginBottom !== '-40px') {
                parentDiv.style.marginBottom = '-40px'
              } else {
                parentDiv.style.marginBottom = `${isMobile ? '-20px' : '-20px' }`
              }
              if (parentDiv.style.marginTop !== '0px') {
                parentDiv.style.marginTop = '0px'
              } else {
                parentDiv.style.marginTop = `${isMobile ? '12px' : '12px' }`
              }
            })
          }, 150)
        })
      })
    }
  })
  //calcular o tamanho do top para o sticky do menu desktop
  function updateStickyTop() {
    const menu = document.getElementById('logo-menu-principal')
    if (!menu) return
    const vh = window.innerHeight
    const menuHeight = menu.offsetHeight
    // Calcula o valor para alinhar a borda inferior do menu à viewport.
    let newTop = vh - menuHeight
    menu.style.top = (vh < menuHeight ? newTop : 0) + 'px'
  }
  window.addEventListener('load', updateStickyTop)
  window.addEventListener('resize', updateStickyTop)
  // NAS OUTRAS PAGS VAI SER ESSE SCRIPT
  // document.addEventListener("DOMContentLoaded", function () {
  // 	const listaButton = document.getElementById("lista-button");
  // 	const gridButton = document.getElementById("grid-button");
  // 	listaButton.addEventListener("click", function () {
  // 			// Esconder todas as grids e mostrar todas as listas
  // 			document.querySelectorAll(".estilo-grid").forEach(grid => grid.classList.add("hidden"));
  // 			document.querySelectorAll(".estilo-lista").forEach(lista => lista.classList.remove("hidden"));
  // 			document.querySelectorAll(".estilo-lista").forEach(lista => lista.classList.add("mt-[250px]"));
  // 			// Esconder botão lista e mostrar botão grid
  // 			listaButton.classList.add("hidden");
  // 			gridButton.classList.remove("hidden");
  // 	});
  // 	gridButton.addEventListener("click", function () {
  // 			// Esconder todas as listas e mostrar todas as grids
  // 			document.querySelectorAll(".estilo-lista").forEach(lista => lista.classList.add("hidden"));
  // 			document.querySelectorAll(".estilo-lista").forEach(lista => lista.classList.remove("mt-[250px]"));
  // 			document.querySelectorAll(".estilo-grid").forEach(grid => grid.classList.remove("hidden"));
  // 			// Esconder botão grid e mostrar botão lista
  // 			gridButton.classList.add("hidden");
  // 			listaButton.classList.remove("hidden");
  // 	});
  // });
  // 		const menuBtn = document.getElementById("menu-btn");
  // 		const menu = document.getElementById("menu");
  // 		menuBtn.addEventListener("click", () => {
  // 				menuBtn.classList.toggle("open");
  // 				menu.classList.toggle("open");
  // 		})
}
